"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const valueIsControlsFontSizeSpecification_1 = __importDefault(require("./valueIsControlsFontSizeSpecification"));
const valueIsControlsStyleComplexUnit_1 = __importDefault(require("./valueIsControlsStyleComplexUnit"));
const valueIsControlsColorSpecification_1 = __importDefault(require("./valueIsControlsColorSpecification"));
const valueIsControlsListStyles = (0, ts_validators_1.buildValueIsShape)('ListStyles', {
    tab: (0, ts_validators_1.buildValueIsOneOf)([
        (0, ts_validators_1.buildValueIsShape)('ListTabStyle', {
            background: (0, ts_validators_1.buildValueIsOneOf)([
                valueIsControlsColorSpecification_1.default,
                ts_validators_1.valueIsUndefined,
            ]),
            color: (0, ts_validators_1.buildValueIsOneOf)([
                valueIsControlsColorSpecification_1.default,
                ts_validators_1.valueIsUndefined,
            ]),
            fontSizeSeparator: (0, ts_validators_1.buildValueIsOneOf)([
                ts_validators_1.valueIsUndefined,
                valueIsControlsFontSizeSpecification_1.default,
            ]),
            fontSizeTopBar: (0, ts_validators_1.buildValueIsOneOf)([
                ts_validators_1.valueIsUndefined,
                valueIsControlsFontSizeSpecification_1.default,
            ]),
            heightAutoSeparator: (0, ts_validators_1.buildValueIsOneOf)([
                ts_validators_1.valueIsUndefined,
                ts_validators_1.valueIsBoolean,
            ]),
            heightAutoTopBar: (0, ts_validators_1.buildValueIsOneOf)([
                ts_validators_1.valueIsUndefined,
                ts_validators_1.valueIsBoolean,
            ]),
            heightSeparator: (0, ts_validators_1.buildValueIsOneOf)([
                ts_validators_1.valueIsUndefined,
                valueIsControlsStyleComplexUnit_1.default,
            ]),
            heightTopBar: (0, ts_validators_1.buildValueIsOneOf)([
                ts_validators_1.valueIsUndefined,
                valueIsControlsStyleComplexUnit_1.default,
            ]),
        }),
        ts_validators_1.valueIsUndefined,
    ]),
});
exports.default = valueIsControlsListStyles;
